import config from '../../config/local-config'
import apiConfig from '../../config/api-config'

export default function transformComponents(orderDetails) {
  if (!config.orderDetailsBreakSetKit) return orderDetails

  const { parts } = orderDetails
  const reversedParts = []
  const lineItems = Array.isArray(parts) ? parts : [parts]

  lineItems.forEach(part => {
    let { components = [] } = part

    if (!Array.isArray(components)) {
      components = [components]
    }

    if (Array.isArray(components) && components.length) {
      components.forEach(component => {
        reversedParts.push({
          ...component,
          parentSku: {
            ...part,
            sku_title: part.sku_title || `${part.sku} ${part.brandText} ${part.part_name || component.part_name || ''}`,
            ImageURL: part.ImageURL || `${apiConfig.partsImage}/image/upload/d_noimage.jpg/images/${(part.sku || '').toLowerCase()}_1`,
            components: undefined,
          },
          sku_title: `${component.sku} ${component.brandText} ${component.part_name}`,
          ImageURL: `${apiConfig.partsImage}/image/upload/d_noimage.jpg/images/${(component.sku || '').toLowerCase()}_1`,
          order_item_status: component.order_item_status_comp,
          list: component.list_price || component.list,
        })
      })
    } else {
      reversedParts.push({
        ...part,
        sku_title: part.sku_title || `${part.sku} ${part.brandText} ${part.part_name || ''}`,
        ImageURL: part.ImageURL || `${apiConfig.partsImage}/image/upload/d_noimage.jpg/images/${(part.sku || '').toLowerCase()}_1`,
        components: undefined,
        list: part.list === '0' ? part.list_price : part.list,
      })
    }
  })

  return { ...orderDetails, parts: reversedParts }
}
